import { isEmpty, pick } from 'lodash';

import { getDirtyValues } from 'lib/helpers/utility';

import { formatDates } from './formatDates';

export const checkUnsavedChanges = (values, initialValues) => {
  const fields = [
    // appointment
    'starts_at',
    'ends_at',
    'resources',
    'status',
    'location',
    'virtual_link',
    'tag_ids',
    'practice_note',
    'practitioner_id',
    'form_ids',
    //invoices
    'tax',
    'discount',
    'products',
    'procedures',
    'modifiedCoPayment',
    'modifiedDeductible',
    'modifiedCoInsurance',
    'modifiedSelfPay',
    // timeline
    'checkin',
    'timeline_status',
    'arrivalUpdate',
    //recurrence
    'repeat_event',
    'repeat_every',
    'ends_type',
    'repeat_on',
    'events',
    'weekdays',
    'end_date'
  ];

  const { products, procedures, last_applied, tax, discount } = initialValues?.invoice || {};

  const otherFields = {
    products: products || [],
    procedures: procedures || [],
    modifiedCoPayment: last_applied?.co_payment?.value ?? null,
    modifiedDeductible: last_applied?.deductible?.value ?? null,
    modifiedCoInsurance: last_applied?.co_insurance?.value ?? null,
    modifiedSelfPay: last_applied?.self_pay?.value ?? null,
    tax,
    discount
  };

  const oldAppt = { ...pick(initialValues, fields), ...otherFields };
  const newAppt = { ...oldAppt, ...pick(values, fields) };

  // use formatDates because on date change the date is converted from UTC to local time
  const formattedValues = formatDates(oldAppt);
  const formattedInitialValues = formatDates(newAppt);

  const dirtyValues = getDirtyValues(formattedInitialValues, formattedValues);

  const recurrenceFields = [
    'end_date',
    'repeat_event',
    'repeat_every',
    'ends_type',
    'repeat_on',
    'events',
    'weekdays'
  ];

  const valuesThatUpdateOnlyThisAppointment = [
    'status',
    'tax',
    'discount',
    'modifiedCoPayment',
    'modifiedDeductible',
    'modifiedCoInsurance',
    'modifiedSelfPay',
    'checkin',
    'timeline_status',
    'arrivalUpdate',
    ...recurrenceFields
  ];

  const updateOnlyThisAppointment =
    values.entity_changed ||
    !values.isRecurrence ||
    Object.keys(dirtyValues).filter((key) => valuesThatUpdateOnlyThisAppointment.includes(key))
      .length > 0;

  // eslint-disable-next-line no-prototype-builtins
  const updateRecurrence = recurrenceFields.some((field) => dirtyValues.hasOwnProperty(field));

  return { isUnsaved: !isEmpty(dirtyValues), updateOnlyThisAppointment, updateRecurrence };
};
